import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDate, GetSelectedDropdownValues, InitializeDateSelector, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { TableColumnGroup, TableColumnVisibilityController } from "../../../../shared/scripts/table-column-visibility";
import { FinancialEntry } from "./financials.entities";
import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";
import { Unique } from "../../../../shared/scripts/array-functions";
import { FinancialSpendEntry } from "./financials.spend.entities";
import { forEach } from "lodash";
import _ from 'lodash';


export class EstimatedSpendTable implements IFilter {
    tableId: string = "spend-table";
    tableWrapperId: string = this.tableId + "_wrapper";
    allItems: FinancialSpendEntry[];
    currentItems: FinancialSpendEntry[];
    categoryItems: FinancialSpendEntry[] = [];
    currentCategoryItems: FinancialSpendEntry[];
    tableColumnController: TableColumnVisibilityController;
    tableColumnGroupController: TableColumnVisibilityController;
    groupTableColumns: TableColumnGroup[];
    dataTables: any[] = [];
    dataTablesMap: Map<string, any> = new Map<string, any>();
    childTable: any;



    constructor(financials: FinancialSpendEntry[]) {
        financials.forEach(financial => financial.initialize());
        
        this.allItems = financials;
        this.currentItems = this.allItems;

        this.categoryItems = this.getCategoryItems(this.allItems);
        this.currentCategoryItems = this.categoryItems;

        this.initializeGroupDataTable("spend-table", this.categoryItems);
        this.initializeDataTable("no-group-table", this.allItems);

        this.initializeFilters();
        this.setupInputWatcher()


        let searchBar = document.querySelector('.search-bar-input');
        (searchBar as HTMLElement).style.visibility = 'hidden';


        $('a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
            //to setup dropdowns to go downwards

            if (e.currentTarget.id == "spend-tab") {
                ['#study-spend-dropdown', '#category-spend-dropdown', '#overage-spend-dropdown'].forEach((id: string) => $(id).selectpicker("refresh"));
            }
        });
        $("#category-tab").on('click', () => {
            (searchBar as HTMLElement).style.visibility = 'hidden';

            setTimeout(() => {
                forEach(this.dataTables, (table) => {
                    table.columns.adjust().draw();
                });
                this.dataTablesMap.get("group").columns.adjust().draw();
                

            }, 500)
        });

        $("#no-group-tab").on('click', () => {
            (searchBar as HTMLElement).style.visibility = 'visible';

            setTimeout(() => {
                forEach(this.dataTables, (table) => {
                    table.columns.adjust().draw();
                });

            }, 500)
        });


        return this;
    }


    initializeDataTable(tableId: string, data: FinancialSpendEntry[]) {
        let tableWrapperId: string = tableId + "_wrapper";
        let columns: any[] = [          
            { data: "Platform", title: "Protocol", className: "platform text-left font-size12 nowrap" },
            { data: "Category", title: "Category", className: "category text-left font-size12 nowrap" },
            { data: "Deliverable", title: "Deliverable", className: "deliverable text-left font-size12 nowrap" },
            { data: "Unit_Desc", title: "Unit", className: "unit-desc text-left font-size12 nowrap" },
            { data: "units_budgeted_Display", title: "Budget:<br>Units", className: "units-budgeted text-left font-size12 nowrap" },
            { data: "cost_budgeted_Display", title: "Budget:<br>Dollars", className: "cost-budgeted text-left font-size12 nowrap" },
            { data: "Latest_Invoice", title: "Latest Invoice", className: "latest-invoice text-left font-size12 nowrap" },
            { data: "Billed_to_Date_Display", title: "Invoiced:<br>Dollars", className: "billed-to-date text-left font-size12 nowrap" },
            { data: "est_units_Display", title: "Estimated:<br>Units", className: "est-units text-left font-size12 nowrap" },
            { data: "est_spending_Display", title: "Estimated:<br>Dollars", className: "est-spending text-left font-size12 nowrap" },
            { data: "isOverspent_Display", title: "Overspent", className: "overspent text-left font-size12 nowrap" },
            { data: "Overspending_Units_Display", title: "Overspend:<br>Units", className: "overspending-units text-left font-size12 nowrap" },
            { data: "Overspending_Cost_Display", title: "Overspend:<br>Dollars", className: "overspending-cost text-left font-size12 nowrap" },
            { data: "source", title: "Estimate: Source", className: "source text-left font-size12 nowrap" },
            { data: "IdSort", title: "idSort", className: "idsort text-left font-size12 nowrap" },


        ];

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Protocol", true, [], "platform"),
            new TableColumnGroup("Category", true, [], "category"),
            new TableColumnGroup("Deliverable", true, [], "deliverable"),
            new TableColumnGroup("Unit", true, [], "unit-desc"),
            new TableColumnGroup("Budget: Units", false, [], "units-budgeted"),
            new TableColumnGroup("Budget: Dollars", true, [], "cost-budgeted"),
            new TableColumnGroup("Latest Invoice", false, [], "latest-invoice"),
            new TableColumnGroup("Invoiced: Dollars", true, [], "billed-to-date"),
            new TableColumnGroup("Estimated: Units", false, [], "est-units"),
            new TableColumnGroup("Estimated: Dollars", true, [], "est-spending"),
            new TableColumnGroup("Overspent", false, [], "overspent"),
            new TableColumnGroup("Overspend: Units", false, [], "overspending-units"),
            new TableColumnGroup("Overspend: Dollars", true, [], "overspending-cost"),
            new TableColumnGroup("Estimate: Source", false, [], "source"),
        ];

        let dataTable: any = $('#' + tableId).DataTable({
            retrieve: true,
            columnDefs: [
                { targets: [14], visible: false }
            ],
            "dom": '<"top-controls"<"spacer1"><"column-select"><"spacer"><"added-since"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            //scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Invoices Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                this.setCellPercentValue(row, 'td.overspending-cost', this.getCellColorByValue(data.Overspending_Cost), 100);
            },
            order: [
                [0, 'asc'],
                [14, 'asc']
            ],
            data: data
        });

        $("#" + tableWrapperId + " .top-controls").addClass('row mx-0 spend-controls');

        $("#" + tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + tableWrapperId + " .column-select").empty().html('<div id="' + tableId + '-column-select"></div>');

        $("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + tableWrapperId + " .spacer1").addClass('col-12 col-md-3 nav-spacer');
        $("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(tableId, (tableId + '-column-select'), tableColumnGroups);

        $('#' + tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(dataTable.rows({ search: 'applied' }).count(), tableId);
        });
        this.setCountFoundLabel(data.length, tableId);

        $("#spend-tab").on('click', () => {
            setTimeout(() => {
                dataTable.columns.adjust().draw();
            }, 500)
        });

        this.dataTablesMap.set("no-group", dataTable);
        //this.childTable = dataTable;
        this.dataTables.push(dataTable);


    }

    initializeGroupDataTable(tableId: string, data: FinancialSpendEntry[]) {
        let tableWrapperId: string = tableId + "_wrapper";
        let columns: any[] = [
            { data: "Platform", title: "Protocol", className: "platform text-left font-size12 nowrap" },
            { data: "Category_Display", title: "Category", className: "category text-left font-size12 nowrap" },
            { data: "Deliverable", title: "Deliverable", className: "deliverable text-left font-size12 nowrap" },
            { data: "Unit_Desc", title: "Unit", className: "unit-desc text-left font-size12 nowrap" },
            { data: "units_budgeted_Display", title: "Budget:<br>Units", className: "units-budgeted text-left font-size12 nowrap" },
            { data: "cost_budgeted_Display", title: "Budget:<br>Dollars", className: "cost-budgeted text-left font-size12 nowrap" },
            { data: "Latest_Invoice", title: "Latest Invoice", className: "latest-invoice text-left font-size12 nowrap" },
            { data: "Billed_to_Date_Display", title: "Invoiced:<br>Dollars", className: "billed-to-date text-left font-size12 nowrap" },
            { data: "est_units_Display", title: "Estimated:<br>Units", className: "est-units text-left font-size12 nowrap" },
            { data: "est_spending_Display", title: "Estimated:<br>Dollars", className: "est-spending text-left font-size12 nowrap" },
            { data: "isOverspent_Display", title: "Overspent", className: "overspent text-left font-size12 nowrap" },
            { data: "Overspending_Units_Display", title: "Overspend:<br>Units", className: "overspending-units text-left font-size12 nowrap" },
            { data: "Overspending_Cost_Display", title: "Overspend:<br>Dollars", className: "overspending-cost text-left font-size12 nowrap" },
            { data: "source", title: "Estimate: Source", className: "source text-left font-size12 nowrap" },
            { data: "IdSort", title: "idSort", className: "idsort text-left font-size12 nowrap" },
        ];

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Protocol", true, [], "platform"),
            new TableColumnGroup("Category", true, [], "category"),
            new TableColumnGroup("Deliverable", true, [], "deliverable"),
            new TableColumnGroup("Unit", true, [], "unit-desc"),
            new TableColumnGroup("Budget: Units", false, [], "units-budgeted"),
            new TableColumnGroup("Budget: Dollars", true, [], "cost-budgeted"),
            new TableColumnGroup("Latest Invoice", false, [], "latest-invoice"),
            new TableColumnGroup("Invoiced: Dollars", true, [], "billed-to-date"),
            new TableColumnGroup("Estimated: Units", false, [], "est-units"),
            new TableColumnGroup("Estimated: Dollars", true, [], "est-spending"),
            new TableColumnGroup("Overspent", false, [], "overspent"),
            new TableColumnGroup("Overspend: Units", false, [], "overspending-units"),
            new TableColumnGroup("Overspend: Dollars", true, [], "overspending-cost"),
            new TableColumnGroup("Estimate: Source", false, [], "source"),
        ];

        this.groupTableColumns = tableColumnGroups;

        let dataTable: any = $('#' + tableId).DataTable({
            columnDefs: [
                { targets: [14], visible: false }
            ],
            "dom": '<"top-controls"<"spacer1"><"column-select"><"spacer"><"added-since"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Invoices Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            createdRow: (row, data: any, index) => {
                this.setCellPercentValue(row, 'td.overspending-cost', this.getCellColorByValue(data.Overspending_Cost), 100);
            },
            order: [
                [0, 'asc'],
                [14, 'asc']
            ],
            data: data
        });

        $("#" + tableWrapperId + " .top-controls").addClass('row mx-0 spend-controls');

        $("#" + tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + tableWrapperId + " .column-select").empty().html('<div id="' + tableId + '-column-select"></div>');

        $("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + tableWrapperId + " .spacer1").addClass('col-12 col-md-3 nav-spacer');
        $("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnGroupController = new TableColumnVisibilityController(tableId, (tableId + '-column-select'), tableColumnGroups);

        $('#' + tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(dataTable.rows({ search: 'applied' }).count(), tableId);
        });
        this.setCountFoundLabel(data.length, tableId);

        $("#spend-tab").on('click', () => {
            setTimeout(() => {
                dataTable.columns.adjust().draw();
            }, 500)
        });

        dataTable.on('click', 'td.category', (e) => {
            let tr = e.target.closest('tr');
            let rowIndex = Array.from(tr.parentNode.children).indexOf(tr);

            let row = dataTable.row(tr);

            let categoryName = row.selector.rows.childNodes[1].innerText;
            let category = this.currentCategoryItems[rowIndex].ID;
            let childItems = this.currentCategoryItems.filter(financial => financial.Category == categoryName).concat(this.currentItems.filter(financial => financial.Category == categoryName))
            this.showModal(category);

            if (!this.dataTablesMap.has("child-table-" + category)) this.initializeChildDataTable("child-table-" + category, childItems);
            else {
                this.dataTablesMap.get("child-table-" + category).destroy();
                this.initializeChildDataTable("child-table-" + category, childItems);
            }

            setTimeout(() => {
                this.childTable.columns.adjust().draw();
            }, 500);
        });
        this.dataTablesMap.set("group", dataTable);

    }

    initializeChildDataTable(tableId: string, data: FinancialSpendEntry[]) {
        let tableWrapperId: string = tableId + "_wrapper";
        let columns: any[] = [
            { data: "Platform", title: "Protocol", className: "platform text-left font-size12 nowrap" },
            { data: "Category", title: "Category", className: "category text-left font-size12 nowrap" },
            { data: "Deliverable", title: "Deliverable", className: "deliverable text-left font-size12 nowrap" },
            { data: "Unit_Desc", title: "Unit", className: "unit-desc text-left font-size12 nowrap" },
            { data: "units_budgeted_Display", title: "Budget:<br>Units", className: "units-budgeted text-left font-size12 nowrap" },
            { data: "cost_budgeted_Display", title: "Budget<br>Dollars", className: "cost-budgeted text-left font-size12 nowrap" },
            { data: "Latest_Invoice", title: "Latest Invoice", className: "latest-invoice text-left font-size12 nowrap" },
            { data: "Billed_to_Date_Display", title: "Invoiced:<br>Dollars", className: "billed-to-date text-left font-size12 nowrap" },
            { data: "est_units_Display", title: "Estimated:<br>Units", className: "est-units text-left font-size12 nowrap" },
            { data: "est_spending_Display", title: "Estimated:<br>Dollars", className: "est-spending text-left font-size12 nowrap" },
            { data: "isOverspent_Display", title: "Overspent", className: "overspent text-left font-size12 nowrap" },
            { data: "Overspending_Units_Display", title: "Overspend:<br>Units", className: "overspending-units text-left font-size12 nowrap" },
            { data: "Overspending_Cost_Display", title: "Overspend:<br>Dollars", className: "overspending-cost text-left font-size12 nowrap" },
            { data: "source", title: "Estimate: Source", className: "source text-left font-size12 nowrap" },
            { data: "IdSort", title: "idSort", className: "idsort text-left font-size12 nowrap" },
            { data: "CategorySort", title: "idSort", className: "category-sort text-left font-size12 nowrap" },


        ];

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Protocol", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Protocol"), [], "platform"),
            new TableColumnGroup("Category", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Category"), [], "category"),
            new TableColumnGroup("Deliverable", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Deliverable"), [], "deliverable"),
            new TableColumnGroup("Unit", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Unit"), [], "unit-desc"),
            new TableColumnGroup("Budget: Units", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Budget: Units"), [], "units-budgeted"),
            new TableColumnGroup("Budget: Dollars", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Budget: Dollars"), [], "cost-budgeted"),
            new TableColumnGroup("Latest Invoice", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Latest Invoice"), [], "latest-invoice"),
            new TableColumnGroup("Invoiced: Dollars", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Invoiced: Dollars"), [], "billed-to-date"),
            new TableColumnGroup("Estimated: Units", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Estimated: Units"), [], "est-units"),
            new TableColumnGroup("Estimated: Dollars", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Estimated: Dollars"), [], "est-spending"),
            new TableColumnGroup("Overspent", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Overspent"), [], "overspent"),
            new TableColumnGroup("Overspend: Units", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Overspend: Units"), [], "overspending-units"),
            new TableColumnGroup("Overspend: Dollars", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Overspend: Dollars"), [], "overspending-cost"),
            new TableColumnGroup("Estimate: Source", GetSelectedDropdownValues("#spend-table-column-filter-dropdown").includes("Estimate: Source"), [], "source"),
        ];

        let dataTable: any = $('#' + tableId).DataTable({
            columnDefs: [
                { targets: [14], visible: false },
                { targets: [15], visible: false },
            ],
            "dom": '<"top-controls"<"column-select"><"search-bar"f><"added-since"><"spacer"><"count-found"B>>rtip',
            autoWidth: true,
            info: false,
            paging: false,
            pagingType: 'simple',
            pageLength: 50,
            search: true,
            scrollX: true,
            scrollY: '70vh',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 2
            },
            columns: columns,
            buttons: [
                {
                    extend: 'csv',
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8',
                    title: "RECOVER-CT Invoices Export"
                    //exportOptions: {
                    //    columns: [1, 2, 3, 4]
                    //}
                }
            ],
            createdRow: (row, data: any, index) => {
                //cell formatting on percentages
                this.setCellPercentValue(row, 'td.overspending-cost', this.getCellColorByValue(data.Overspending_Cost), 100);
            },
            order: [
                [15, 'asc'],
                [0, 'asc'],
                [14, 'asc']
            ],
            data: data
        });

        $("#" + tableWrapperId + " .top-controls").addClass('row mx-0');

        $("#" + tableWrapperId + " .column-select").addClass('col-12 col-md-3 px-0');
        $("#" + tableWrapperId + " .column-select").empty().html('<div id="' + tableId + '-column-select"></div>');

        $("#" + tableWrapperId + " .search-bar").addClass('col-12 col-md-3');

        $("#" + tableWrapperId + " .spacer").addClass('col-12 col-md-3');
        $("#" + tableWrapperId + " .count-found").addClass('col-12 col-md-3 d-flex justify-content-end vertical-align-middle align-self-end mt-2 pr-0');
        //<span id="people-found-count" class="font-italic font-size12" > </span>
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"><span id=\"' + tableId + '-found-count\"></span></div>');
        $("#" + tableWrapperId + " .count-found").prepend('<div class=\"table-message d-inline-block align-self-center mr-2\"></div>');

        this.tableColumnController = new TableColumnVisibilityController(tableId, (tableId + '-column-select'), tableColumnGroups);

        $('#' + tableId).on('search.dt', (e, settings) => {
            this.setCountFoundLabel(dataTable.rows({ search: 'applied' }).count(), tableId);
        });
        this.setCountFoundLabel(data.length, tableId);

        $("#spend-tab").on('click', () => {
            setTimeout(() => {
                dataTable.columns.adjust().draw();
            }, 500)
        });
        this.dataTablesMap.set(tableId, dataTable);
        this.dataTables.push(dataTable);
        this.childTable = dataTable;
        
    }

    initializeFilters() {
        let studiesLists: string[] = [];
        this.allItems.map(invoice => {
            if (!studiesLists.includes(invoice.Platform) && invoice.Platform != null && invoice.Platform != "") {
                studiesLists.push(invoice.Platform);
            }
        })
        studiesLists.sort();
        let categoriesLists: string[] = [];
        forEach(this.categoryItems, financial => {
            if (!categoriesLists.includes(financial.Category)) categoriesLists.push(financial.Category);
        });
        let overageLists: string[] = [];
        overageLists.push("No Overspending");
        overageLists.push("Between $0 and $50k");
        overageLists.push("Over $50k");

        InitializeFilterDropdown('#study-spend-dropdown', studiesLists, this);
        InitializeFilterDropdown('#category-spend-dropdown', categoriesLists, this);
        InitializeFilterDropdown('#overage-spend-dropdown', overageLists, this);
    }

    triggerFilter(): void {
        let items = this.allItems;
        let categoryItems = this.categoryItems;
        // Study
        items = items.filter(item => GetSelectedDropdownValues("#study-spend-dropdown").includes(item.Platform));
        categoryItems = this.getCategoryItems(items);

        // Overage
        items = items.filter(item => this.isInOverspendingRange(item.Overspending_Cost, GetSelectedDropdownValues("#overage-spend-dropdown")));
        categoryItems = categoryItems.filter(item => this.isInOverspendingRange(item.Overspending_Cost, GetSelectedDropdownValues("#overage-spend-dropdown")));
        
        // Category
        items = items.filter(item => GetSelectedDropdownValues("#category-spend-dropdown").includes(item.Category));
        categoryItems = categoryItems.filter(item => GetSelectedDropdownValues("#category-spend-dropdown").includes(item.Category));
        


        this.currentItems = items;
        this.currentCategoryItems = categoryItems;
        this.updateContent()
    }

    isInOverspendingRange(overspent: number, selectedRange: string[]): boolean {
        if (selectedRange.includes("No Overspending") && overspent <= 0) return true;
        if (selectedRange.includes("Between $0 and $50k") && (overspent > 0 && overspent < 50000)) return true;
        if (selectedRange.includes("Over $50k") && overspent > 50000) return true;
    }

    updateContent(): void {

        this.dataTablesMap.forEach((value, key) => {
            if (key == "no-group") {              
                value.clear();
                value.rows.add(this.currentItems).draw();
            }
            else if (key == "group") {
                value.clear();
                value.rows.add(this.currentCategoryItems).draw();
            }
        });
    }

    setCountFoundLabel(count: number, tableId: string): void {

        switch (count) {
            case 0: $('#' + tableId + '-found-count').text("No Entries Found"); break;
            case 1: $('#' + tableId + '-found-count').text("1 Entry Found"); break;
            default: $('#' + tableId + '-found-count').text(FormatNumberWithCommas(count + "") + " Entries Found");
        }
    }

    resetFilters(): void {
        const inputElement: HTMLInputElement | null = document.getElementById('data-search') as HTMLInputElement;
        inputElement.value = "";
        this.dataTables.forEach((dataTable: any) => {
            dataTable.search(inputElement.value).draw();
        })
        $("#study-spend-dropdown").selectpicker('selectAll');
        $("#category-spend-dropdown").selectpicker('selectAll');
        $("#overage-spend-dropdown").selectpicker('selectAll');
        this.triggerFilter();
    }

    setupInputWatcher(): void {
        const inputElement: HTMLInputElement | null = document.getElementById('data-search') as HTMLInputElement;

        inputElement.addEventListener('input', () => {
            this.dataTables.forEach((dataTable: any) => {
                dataTable.search(inputElement.value).draw();
            })
        });

    }

    showModal(category: string): void {
        $('#spendModal').modal('show');
        //<table id="child-table" class="table table-striped selectable-rows condense-vertical w-100" style="width:100%"></table>
        $("#child-table").empty().html('<table id="child-table-'+ category +'" class="table table-striped selectable-rows condense-vertical w-100" style="width:100%"></table>');
    }


    getCategoryItems(items: FinancialSpendEntry[]): FinancialSpendEntry[] {
        let financials = items;
        let categories = Unique(financials.map(financial => financial.Category), true);
        let localCategoryItems = [];
        let platforms = Unique(financials.map(financial => financial.Platform), true);
        let platformName = "";
        if (platforms.length == 5) platformName = "All Platforms";
        else if (platforms.length > 1) platformName = "Selected Platforms";
        else platformName = platforms[0];
        forEach(categories, category => {
            let temp = new FinancialSpendEntry;
            temp.Platform = platformName;
            temp.Category = category;
            temp.ID = financials.filter(financial => financial.Category == category)[0].ID.split('.')[0];
            temp.Deliverable = "All Deliverables";
            temp.Unit_Desc = "All Units";
            temp.units_budgeted = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.units_budgeted, 0));
            temp.Latest_Invoice = financials.filter(financial => financial.Category == category).reduce((latest, current) => {
                const latestDate = new Date(latest);
                const currentDate = new Date(current.Latest_Invoice);
                return currentDate > latestDate ? current.Latest_Invoice : latest;
            }, financials[0]?.Latest_Invoice || null);
            temp.Billed_to_Date = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Billed_to_Date, 0));
            temp.cost_budgeted = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.cost_budgeted, 0));
            temp.est_spending = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.est_spending, 0));
            temp.est_units = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.est_units, 0));
            temp.Overspending_Units = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Overspending_Units, 0));
            temp.Overspending_Cost = Math.round(financials.filter(financial => financial.Category == category).reduce((acc, item) => acc + item.Overspending_Cost, 0));
            temp.source = "All Sources";
            temp.isOverspent = temp.Overspending_Cost > 0;
            temp.CategorySort = 1;
            temp.initialize();

            localCategoryItems.push(temp);
        });
        localCategoryItems.sort((a, b) => parseInt(a.ID) - parseInt(b.ID));
        return localCategoryItems;
    }

    private setCellPercentValue(row: any, cell: string, color: string, count: number): void {
        $(cell, row).css('background-color', color);
        $(cell, row).css('font-weight', "bold");
        $(cell, row).attr('title', 'n = ' + count);
        $(cell, row).attr('data-toggle', 'tooltip');
        $(cell, row).attr('data-placement', 'top');
    }

    private getCellColorByValue(value: number): string {
        if (value <= 0) return "#7fb87f";
        else if (value >= 50000) return "#f07d7d";
        else return "#fce77d";

    }
}